import { Typography, Grid } from '@mui/material';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import DashboardCard from '../common/DashboardCard';

function AccountInformation(props: any) {
    const dashboardInfo = props.dashboardInfo;
    const accentColor = props.accentColor;
    return (
        <DashboardCard
            title="Account Information"
            icon={<AccountBoxIcon />}
            accentColor={accentColor}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="body1" color="text.secondary">
                        Created: {dashboardInfo.creationDate}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" color="text.secondary">
                        Number of Fleets: {dashboardInfo.totalFleets}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" color="text.secondary">
                        Number of Vehicles: {dashboardInfo.totalVehicles}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" color="text.secondary">
                        Last Accessed: {dashboardInfo.lastAccessedDate}
                    </Typography>
                </Grid>
            </Grid>
        </DashboardCard>
    );
}

export default AccountInformation;
